import { IPadding, IVector3, ScreenshotMimeType } from '@inter-ikea-betrakta/viewer';

interface IDirections {
  front: IVector3;
  left: IVector3;
  right: IVector3;
  behind: IVector3;
}

const directions: IDirections = {
  front: { x: 0, y: 0, z: -1 },
  left: { x: -0.48, y: 0, z: -0.35 },
  right: { x: 0.48, y: 0, z: -0.35 },
  behind: { x: 0, y: 0, z: 1 }
};

// 30 rem customizeMenu width
const customizeMenuWidthInPx = 30 * parseFloat(getComputedStyle(document.documentElement).fontSize);

const screenshotDesktopHeightOverride = 600;

let windowHeight = window.innerHeight;
let windowWidth = window.innerWidth;

if (windowHeight < 1 || windowWidth < 1) {
  windowHeight = 1920;
  windowHeight = 1080;
}

const params = {
  size: {
    desktop: {
      x: windowWidth - customizeMenuWidthInPx,
      y: windowHeight
    },
    mobile: {
      x: windowWidth,
      y: windowHeight
    }
  }
};

const padding: IPadding = {
  top: 60,
  right: 60,
  bottom: 60,
  left: 60
};

const imageSettings = {
  ao_settings: { enabled: true },
  mime_type: ScreenshotMimeType.JPEG,
  image_compression: 0.9
};

const aspectRatio = 1.25;

export default {
  directions,
  params,
  padding,
  screenshotDesktopHeightOverride,
  imageSettings,
  aspectRatio
};
